export { default as DocumentViewerModal } from './DocumentViewerModal';
